<template>
  <div :class="classDiv">
    <img
      ref="imagen-gratuidad"
      src="@/assets/img/iconos/gratuidad-4.svg"
      :style="styleImg"
      :class="classImg"
      v-if="gratuidad"
    />
    <FontAwesomeIcon icon="minus" v-else ref="imagen-gratuidad" :class="classSvg" />
    <!--<img
      ref="imagen-gratuidad"
      src="@/assets/img/iconos/sin-gratuidad-4.svg"
      :style="styleImg"
      :class="classImg"
      v-else
    />-->

    <b-tooltip
      :disabled.sync="tooltipDisabled"
      :target="() => $refs['imagen-gratuidad']"
      :title="gratuidadTexto"
    ></b-tooltip>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faMinus);
export default {
  name: "Gratuidad",
  props: {
    gratuidad: { type: Boolean },
    classImg: {
      type: String
    },
    classSvg:{
      type: String
    },
    classDiv: {
      type: String
    },
    styleImg: {
      type: String
    },
    tooltipDisabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    gratuidadTexto() {
      if (this.gratuidad) {
        return "Adscrita a gratuidad";
      } else {
        return "No adscrita a gratuidad";
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/iconos/Gratuidad.vue